export const initialFilter = {
  search: "",
  category_id: undefined,
  subcategories: [],
  skills: [],
  location_id: undefined,
  min_price: 0,
  max_price: 0,
}
export const sorts = [
  {id: 1, prop: "title", label: "NAME"},
  {id: 3, prop: "created_at", label: "SORT.CREATED_AT"},
  {id: 3, prop: "price", label: "PRICE"},
  {id: 4, prop: "rating", label: "SORT.RATING"},
  {id: 4, prop: "views", label: "SORT.VIEWS"},
]